import {
  hasDifferentHomeAddress,
  isMissingVeteranDob,
} from '../../../utils/helpers';
import birthSex from './birthSex';
import contactInformation from './contactInformation';
import dateOfBirth from './dateOfBirth';
import demographicInformation from './demographicInformation';
import homeAddress from './homeAddress';
import mailingAddress from './mailingAddress';
import mothersMaidenName from './mothersMaidenName';
import placeOfBirth from './placeOfBirth';

export const veteranPages = {
  veteranDateOfBirth: {
    path: 'veteran-information/profile-information-dob',
    title: 'Date of birth',
    depends: isMissingVeteranDob,
    ...dateOfBirth,
  },
  veteranPlaceOfBirth: {
    path: 'veteran-information/birth-information',
    title: 'Place of birth',
    ...placeOfBirth,
  },
  veteranMothersMaidenName: {
    path: 'veteran-information/maiden-name-information',
    title: 'Mother’s maiden name',
    ...mothersMaidenName,
  },
  veteranBirthSex: {
    path: 'veteran-information/birth-sex',
    title: 'Sex assigned at birth',
    ...birthSex,
  },
  veteranDemographicInfo: {
    path: 'veteran-information/demographic-information',
    title: 'Race, ethnicity, or origin',
    initialData: {
      'view:demographicCategories': {
        isSpanishHispanicLatino: false,
      },
    },
    ...demographicInformation,
  },
  veteranMailingAddress: {
    path: 'veteran-information/veteran-address',
    title: 'Mailing address',
    ...mailingAddress,
  },
  veteranHomeAddress: {
    path: 'veteran-information/veteran-home-address',
    title: 'Home address',
    depends: hasDifferentHomeAddress,
    ...homeAddress,
  },
  veteranContactInfo: {
    path: 'veteran-information/contact-information',
    title: 'Contact information',
    ...contactInformation,
  },
};
